export default __webpack_public_path__ + "static/media/home.deacc412.mp4";